<div mat-dialog-content class="w-timepicker-dialog">
  <pcp-time
    [color]="color"
    [userTime]="userTime"
    submitLabel="OK"
    i18n-submitLabel
    revertLabel="Cancel"
    i18n-revertLabel
    (revert)="revert()"
    (done)="submit()"
  ></pcp-time>
</div>
